import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class paisService {

    /******* QUERIES ******/

    async listar() {
        const response = await axios
            .get(`${ERP}administracion/pais`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async getBySearch(filter) {
        const response = await axios
            .get(`${ERP}administracion/pais/search?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


}

export default new paisService();